import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export interface LinkProps {
  magicLink?: string;
}

export const Link = types.model({
  magicLink: types.maybe(types.string),
});

export type LinkSnapshot = SnapshotIn<typeof Link>;
export type LinkInstance = Instance<typeof Link>;
